module.exports = __webpack_public_path__ + "img/judicial_img.31af8ad3.png";